import React from 'react'
import Navbar from '../Componants/Navbar'
export default function NoPage() {
  return (
    <div>
      <Navbar/>
      NoPage</div>
  )
}
